module.exports = __webpack_public_path__ + "media/icons/mail@3xb-11870634.svg";